(() => {
  document
    .querySelectorAll("modal-opener img[src*='arty_iframe']")
    .forEach((item) => {
      switchToIframe(item);
    });

  function switchToIframe(item) {
    const modalOpener = item.closest("modal-opener");
    const wrapper = modalOpener.parentElement;

    const string = item.src;

    // remove extension from the end
    const extension = string.substring(string.lastIndexOf(".") + 1);
    const stringWithoutExtension = string.substring(0, string.lastIndexOf("."));

    // split string by _
    const parts = stringWithoutExtension.split("_");
    const a = parts[2];
    const b = parts[3];
    const c = parts[4];

    if (!parts[2]) {
      return;
    }

    const modelId = parts[2];
    const viewerId = !parts[3] ? "default" : parts[3];
    const uiId = !parts[4] ? "default" : parts[4];

    const iframe = document.createElement("iframe");
    iframe.classList.add("arty-model-viewer");
    iframe.src =
      "https://platform.ar-ty.com/api/model-viewer/" +
      modelId +
      "/" +
      viewerId +
      "/" +
      uiId;
    iframe.style.width = "100%";
    iframe.style.display = "block";
    let sibling;
    item
      .closest("li")
      .parentElement.querySelectorAll("li")
      .forEach((item) => {
        let artyImg = item.querySelector("img[src*='arty_iframe']");
        if (!sibling && !artyImg && item.offsetHeight) {
          sibling = item;
        }
      });

    const heightRatio = 1;
    const height =
      heightRatio * (item.offsetWidth || sibling.offsetWidth) + "px";
    iframe.style.minHeight = height;
    iframe.style.border = "none";

    modalOpener.remove();
    wrapper.appendChild(iframe);
  }
})()